import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderDetailManagementTable } from '@components/templates/myAccount/manageOrderDetail/OrderDetailManagementTable';

export interface OrderBillingTableProps {
    address: String;
}

export const OrderBillingTable: FC<OrderBillingTableProps> = ({ address }) => {
    const { t } = useTranslation();

    const translations = {
        address: t('order-billing-table-component.header.address'),
    };

    return (
        <OrderDetailManagementTable
            withActions={false}
            header={[{ text: translations.address }]}
            content={[
                {
                    cells: [{ content: <p style={{ whiteSpace: 'pre-line' }}>{address}</p> }],
                    options: [],
                },
            ]}
        />
    );
};
